
import { Payload } from "@/types/profile";

export const restrictionsPayloads: Payload[] = [
  // Restrictions payloads
  {
    id: "restrictions",
    name: "Restrictions",
    description: "Configure feature restrictions for devices",
    category: "Restrictions",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "allowCamera",
        name: "Allow Camera",
        type: "boolean",
        required: true,
        default: true,
        description: "Allow the use of the camera"
      },
      {
        id: "allowScreenShot",
        name: "Allow Screenshots",
        type: "boolean",
        required: true,
        default: true,
        description: "Allow taking screenshots"
      },
      {
        id: "forceEncryptedBackup",
        name: "Force Encrypted Backups",
        type: "boolean",
        required: false,
        default: true,
        description: "Enforce encryption for device backups"
      },
      {
        id: "allowAppInstallation",
        name: "Allow App Installation",
        type: "boolean",
        required: false,
        default: true,
        description: "Allow installation of apps"
      },
      {
        id: "allowCloudDocumentSync",
        name: "Allow iCloud Document Sync",
        type: "boolean",
        required: false,
        default: true,
        description: "Allow documents to be synced with iCloud"
      }
    ]
  },
  
  // Single App Mode payloads
  {
    id: "single-app-mode",
    name: "Single App Mode",
    description: "Configure Single App Mode",
    category: "Restrictions",
    supportedPlatforms: ["ios", "ipados"],
    configFields: [
      {
        id: "appBundleID",
        name: "App Bundle ID",
        type: "text",
        required: true,
        description: "Bundle ID of the app to use in Single App Mode"
      },
      {
        id: "userEnable",
        name: "User Can Enable/Disable",
        type: "boolean",
        required: false,
        default: false,
        description: "Allow users to enable or disable Single App Mode"
      }
    ]
  },
  
  // Web Content Filter payloads
  {
    id: "web-content-filter",
    name: "Web Content Filter",
    description: "Configure web content filtering",
    category: "Restrictions",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "filterType",
        name: "Filter Type",
        type: "select",
        required: true,
        options: ["Built-in", "Whitelist", "Blacklist"],
        default: "Built-in",
        description: "Type of web filtering to apply"
      },
      {
        id: "permittedURLs",
        name: "Permitted URLs",
        type: "textarea",
        required: false,
        description: "List of permitted URLs (one per line)"
      },
      {
        id: "blockedURLs",
        name: "Blocked URLs",
        type: "textarea",
        required: false,
        description: "List of blocked URLs (one per line)"
      }
    ]
  }
];
